/**
 * State Management Configuration
 * Controls multi-state caching behavior for chart snapshots
 */

/**
 * Maximum number of cached states per chart
 * Older states are removed (LRU) when limit is exceeded
 */
export const MAX_RENDERED_STATES = 5;
